import { History } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { useAuditLogContext } from "@ryde/redux";
import { errors, IAuditLogNormalized } from "@ryde/shared";

import { RideHistoryLogGridRow } from "./grid-row";
import { rideHistoryHeaders } from "./grid.models";

interface IRideHistoryLogGridProps {
  logs: IAuditLogNormalized[];
}

export const RideHistoryLogGrid: FC<IRideHistoryLogGridProps> = ({ logs }) => {
  const { expandedItems, onToggleExpanded } = useAuditLogContext();
  const { t } = useTranslation();

  if (!logs?.length) {
    return (
      <div className="ride-history-log__empty-state">
        <div className="ride-history-log__empty-state-message">
          <History className="ride-history-log__empty-state-icon" />
          {t(errors.auditLog.notFoundAuditLogRecords)}
        </div>
      </div>
    );
  }

  return (
    <div className="ride-history-log__grid-wrapper">
      <div className="ride-history-log__grid">
        <div className="ride-history-log__grid-header">
          <div className="ride-history-log__grid-header-cell ride-history-log__grid-header-cell_expanded"></div>
          {Object.entries(rideHistoryHeaders).map(([key, translationKey]) => (
            <div key={key} className="ride-history-log__grid-header-cell">
              {t(translationKey)}
            </div>
          ))}
        </div>

        <div className="ride-history-log__grid-body">
          {logs?.map((item, index) => (
            <RideHistoryLogGridRow
              key={item.id}
              item={item}
              prevItem={index === 0 ? null : logs[index - 1]}
              isExpanded={expandedItems?.has(item.id)}
              onToggleExpanded={onToggleExpanded}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
